export * from './image-card.component';
